import React from 'react';
import { BudgetDetailsProps } from '../../types';
import { BudgetForm } from './components';

export const BudgetNew = ({ title, libby }: BudgetDetailsProps) => {
  return <BudgetForm libby={libby} title={title} />;
};
